import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { JobWorkAgainstUnitEntity } from './job-work-approval-entity';
import { JobWorkAgainstUnitController } from './job-work-approval-controller';
import { JobworkAgainstUnitService } from './job-work-approval-service';


@Module({
    imports: [TypeOrmModule.forFeature([JobWorkAgainstUnitEntity])],
    controllers: [JobWorkAgainstUnitController],
    providers: [JobworkAgainstUnitService, ApplicationExceptionHandler],
})
export class JobworkAgainstUnitModule {}
